// Third party libraries
import * as $ from 'jquery';

// Mixins
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

export default {
	name: 'modalFindReplaceWithPetName',
	mixins: [inputTextMixins],
	data() {
		return {
			modalContent: null,
			search: ``,
			stringCount: 0
		}
	},
	computed: {
		isDisabled() {
			return this.stringCount > 0 ? false : true;
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show(modalContent) {
			this.search = ``;
			this.modalContent = modalContent.split(" ");
			this.stringCount = 0;

			$(this.$refs.modalFindReplaceWithPetName).modal('show');
		},
		hideModal() {
			$(this.$refs.modalFindReplaceWithPetName).modal('hide');
		},
		searchKeyUp() {
			if (this.search) {
				this.delayTyping(() => {
					this.stringCount = 0;
					
					this.modalContent.map(content => {
						if (content === this.search) {
							++this.stringCount;
						}
					});
				});
			}
		},
		replaceString() {
			this.modalContent.map((content, index) => {
				if (content === this.search) {
					this.modalContent[index] = `PET_NAME`;
				}
			});

			this.$emit('replaceBodyWithPetName', this.modalContent.join(" "));
			this.hideModal();
		}
	}
}